import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import MenuModal from '../../../screens/menu-modal';
import { WrongChoiceIncorrect } from '@dbk/ui-icons';
import Menu from '../../../common/components/icons/menu';

class MenuIcon extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: false,
    };
    this.onChange = this.onChange.bind(this);
    this.handlePressed = this.handlePressed.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handlePressed() {
    this.setState((prevState) => ({ selected: !prevState.selected }));
  }

  handleCloseModal() {
    this.setState({ selected: false });
  }

  onChange (){
    this.setState({ selected: false });
  }

  render() {
    const { onChange } = this.props;
    return (
      <div>
        <TouchableOpacity
          id="notificationIcon"
          onPress={() => this.handlePressed()}
        >
          <span>
            {this.state.selected ? (
              <span>
                <WrongChoiceIncorrect
                  width={24}
                  height={24}
                  color="transparent"
                />
              </span>
            ) : (
              <span>
                <Menu width={24} height={24} color="#999" fill="#999" />
              </span>
            )}
          </span>
        </TouchableOpacity>
        {this.state.selected && (
          <MenuModal onChange={() => this.handleCloseModal()} />
        )}
      </div>
    );
  }
}

MenuIcon.propTypes = {
  selected: PropTypes.bool,
  onChange: PropTypes.func,
};

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
  },
})(MenuIcon);
